import { PAY_TOKEN_BY_SYMBOL } from "./constants";
import { getFundingReadContract } from "./funding/index.js";

export async function isPayTokenSupported(payToken) {
  const contract = getFundingReadContract();
  const ok = await contract.methods.supportedPayToken(payToken).call();
  return ok === true || ok === "true";
}

/** 链上已开启 launchProject 的支付币种符号 */
export async function fetchLaunchablePaySymbols() {
  const symbols = [];
  for (const [symbol, address] of Object.entries(PAY_TOKEN_BY_SYMBOL)) {
    if (await isPayTokenSupported(address)) {
      symbols.push(symbol);
    }
  }
  return symbols;
}

export async function assertPayTokenSupported(payToken, symbolHint = "") {
  const ok = await isPayTokenSupported(payToken);
  if (!ok) {
    const label = symbolHint || payToken;
    throw new Error(`链上未开启该支付代币（${label}），请换币种或联系管理员 setSupportedPayToken`);
  }
}
